export const REQUEST_DOCKET_PARTS = 'REQUEST_DOCKET_PARTS';
export const RECEIVE_DOCKET_PARTS = 'RECEIVE_DOCKET_PARTS';
export const REQUEST_CASE_DATA = 'REQUEST_CASE_DATA';
export const RECEIVE_CASE_DATA = 'RECEIVE_CASE_DATA';
export const SERVICE_ERROR = 'SERVICE_ERROR';
export const RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/irSearchActionTypes.js